import { DateTime } from 'luxon';
import { Adapter } from '../types';

export const isoToDateTimeAdapter: Adapter<string, DateTime> = {
  adapt: (input: string) => DateTime.fromISO(input),
  revert: (input: DateTime) => input.toISO() ?? 'Invalid Date',
};
